import { graphql, useStaticQuery } from "gatsby"

export const useHomePageData = () => {
  const data = useStaticQuery(graphql`
    query {
      heroImage: allSanityMedia(
        filter: { tags: { in: "home-page" }, label: { eq: "home-page-hero" } }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(
                width: 500
                formats: [AUTO, WEBP]
                placeholder: BLURRED
              )
            }
          }
        }
      }

      featuredImage: allSanityMedia(
        filter: {
          tags: { in: "home-page" }
          label: { eq: "home-page-featured-on" }
        }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(
                width: 800
                formats: [AUTO, WEBP]
                placeholder: BLURRED
              )
            }
          }
        }
      }

      card1: allSanityMedia(
        filter: { tags: { in: "home-page" }, label: { eq: "home-page-card-1" } }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(
                width: 800
                formats: [AUTO, WEBP]
                placeholder: BLURRED
              )
            }
          }
        }
      }

      card2: allSanityMedia(
        filter: { tags: { in: "home-page" }, label: { eq: "home-page-card-2" } }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(
                width: 800
                formats: [AUTO, WEBP]
                placeholder: BLURRED
              )
            }
          }
        }
      }

      card3: allSanityMedia(
        filter: { tags: { in: "home-page" }, label: { eq: "home-page-card-3" } }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(
                width: 800
                formats: [AUTO, WEBP]
                placeholder: BLURRED
              )
            }
          }
        }
      }

      help1: allSanityMedia(
        filter: { tags: { in: "home-page" }, label: { eq: "home-page-help-1" } }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(
                width: 400
                formats: [AUTO, WEBP]
                placeholder: BLURRED
              )
            }
          }
        }
      }

      help2: allSanityMedia(
        filter: { tags: { in: "home-page" }, label: { eq: "home-page-help-2" } }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(
                width: 400
                formats: [AUTO, WEBP]
                placeholder: BLURRED
              )
            }
          }
        }
      }

      help3: allSanityMedia(
        filter: { tags: { in: "home-page" }, label: { eq: "home-page-help-3" } }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(
                width: 400
                formats: [AUTO, WEBP]
                placeholder: BLURRED
              )
            }
          }
        }
      }

      help4: allSanityMedia(
        filter: { tags: { in: "home-page" }, label: { eq: "home-page-help-4" } }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(
                width: 400
                formats: [AUTO, WEBP]
                placeholder: BLURRED
              )
            }
          }
        }
      }

      googleReview: allSanityMedia(
        filter: {
          tags: { in: "home-page" }
          label: { eq: "home-page-google-review" }
        }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(formats: [AUTO, WEBP], placeholder: BLURRED)
            }
          }
        }
      }

      googleReviewCircle: allSanityMedia(
        filter: {
          tags: { in: "home-page" }
          label: { eq: "home-page-google-review-circle" }
        }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(formats: [AUTO, WEBP], placeholder: BLURRED)
            }
          }
        }
      }

      awards: allSanityMedia(
        filter: { tags: { eq: "award", in: "home-page" } }
        sort: { label: ASC }
      ) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(formats: [AUTO, WEBP], placeholder: BLURRED)
            }
          }
        }
      }
    }
  `)

  return data
}
